<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="border-bottom pb-2" v-for="item in items" :key="item.id">
          <div class="media">
            <img
              v-if="item.default_image"
              height="50"
              :src="item.default_image.small"
              class="mr-3"
              alt="..."
            />
            <div class="media-body">
              <h5 class="mt-2">{{ item.name }}</h5>
            </div>
          </div>
        </div>

        <button class="btn btn-primary mt-3"  v-on:click="pdf()">PDF</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import catalogueRepo from "@/api/repos/catalogueRepo";

export default {
  mounted() {
    this.items = JSON.parse(localStorage.getItem("catalogue-share-items"));
  },

  data() {
    return {
      loading: false,
      items: [],
    };
  },

  methods: {
    async pdf(){

        if(this.items.length < 1){
            return false;
        }

         this.loading = true

         var ids = "";
         this.items.forEach(element => {
            ids += element.id+",";
         });

         ids = ids.slice(0, -1);

      try {
        let response = await catalogueRepo.catalogueItemsSharePdf(ids);
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `catalogue.pdf`);
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        console.log(error);
      }finally{
        this.loading = false
      }
    }
  },
};
</script>
